import { useMutation } from '@tanstack/react-query';

import { verificationKeys } from './keys';
import { useApi } from '../../ApiClient';
import { tracker } from '../../utilities/tracker';
import { EChannel, EVerificationStatus } from '../components/types';

interface IValidateCodeArgs {
  to: string;
  code: string;
}

interface IValidateCodeResponse {
  sid: string;
  sessionId: string;
  to: string;
  channel: EChannel;
  status: EVerificationStatus;
  dateCreated: string;
  dateUpdated: string;
}

export const useValidateCode = (monolithBaseUrl: string) => {
  const apiClient = useApi();

  return useMutation<
    IValidateCodeResponse | undefined,
    unknown,
    IValidateCodeArgs
  >({
    mutationKey: verificationKeys.validateCode,
    mutationFn: async (args): Promise<IValidateCodeResponse | undefined> => {
      const data = await apiClient?.post<IValidateCodeResponse>(
        `${monolithBaseUrl}/api/mfa/v1/validate`,
        args
      );
      return data;
    },
    onError(error) {
      tracker.track('Validate Code Mutation Failed', {
        errorString: JSON.stringify(error),
      });
    },
  });
};
